export default {
    url: '/medals_power',
    template: require('./view.html'),
    data: {
        title: 'Medals power',
        priority: 900,
    },
    reloadOnSearch: false,
};
